import React, { useEffect } from 'react';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { ParentalPinType, SubpageStore } from '@kaltura-ott/tvpil-shared';

import PinCodeModal from 'components/widgets/Modal/PinCodeModal/PinCodeModal';
import { PinCodeModalTypes } from 'components/widgets/Modal/PinCodeModal/PinCodeModalTypesEnum';
import { useModalContext } from 'context/modal/modal';
import { useStableReactRouter } from 'context/stableReactRouterContext/stableReactRouterContext';
import { useParentalPinStore, useSettingsStore } from 'hooks';
import routes from 'routesPaths';

export const useParentalControlRedirect = () => {
  const { location, navigate } = useStableReactRouter();
  const modalContext = useModalContext();
  const parentalControlStore = useParentalPinStore();
  const { settingsStore } = useSettingsStore();
  const settingsSubPage = settingsStore.children.find((subPage) =>
    location.pathname.includes((subPage as SubpageStore).link),
  );

  useEffect(() => {
    if (settingsSubPage && parentalControlStore.isBlockByParentRating(settingsSubPage)) {
      const onDecline = () => {
        navigate(routes.settings.path);
      };
      const validateParentalControl = (pin: string) =>
        parentalControlStore.validatePin(pin, ParentalPinType.parental, settingsSubPage);

      modalContext.openModal(
        <PinCodeModal
          onDecline={onDecline}
          type={PinCodeModalTypes.EnterParental}
          context={UIDAPresentationTypeEnum.parental_control}
          validatePin={validateParentalControl}
        />,
      );
    }
  }, [location.pathname]);
};
